const VERSION = 'v0.9.2';

export default VERSION;



// WEBPACK FOOTER //
// ../gwi-ads/publisher/src/config/version.js